import { msg } from 'gt-react';
import { CalculatorIcon } from '@phosphor-icons/react';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as pathlessAuthenticatedRoute, requireModules } from '../route';

const QuoteBuilderPage = lazyRouteComponent(
  () => import('./QuoteBuilderPage'),
  'QuoteBuilderPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/quote-builder',
  staticData: {
    app: {
      nav: {
        label: msg('Quote Builder', {
          context: 'sidebar nav label, Sales section',
        }),
        icon: <CalculatorIcon className="h-4 w-4" weight="fill" />,
        group: 'Sales',
        order: 25,
      },
      access: {
        // Open to every Order Management user; the Read:ProductMargins RBAC
        // permission only gates the margin-sensitive elements inside the page
        // (cost/margin/YoY columns and cost metric tiles).
        modulesAnyOf: [ProductModule.ORDER_MANAGEMENT],
      },
    },
  },
  component: QuoteBuilderPage,
  loader: () => ({
    crumb: msg('Quote Builder', { context: 'page breadcrumb' }),
  }),
  // Persist the simulated order (customer + lines) in the URL so it can be
  // bookmarked / shared / survive refresh. Lines are stored compactly as
  // { v: variantId, p: unitPrice, q: quantity }. `.catch` keeps a malformed
  // param (e.g. a cleared `customerId=`) from crashing the page.
  validateSearch: z.object({
    customerId: z.uuid().optional().catch(undefined),
    lines: z
      .array(
        z.object({
          v: z.uuid(),
          p: z.number(),
          q: z.number(),
        }),
      )
      .optional()
      .catch(undefined),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});
